import React from 'react';

const LayoutDefault = ({ children }) => (
  <>
    <main className="site-content">
      {children}
    </main>
  </>
);

export default LayoutDefault;  